const TextInput = ({ value, onChange, label, placeholder = 'Type...' }) => {
	return (
		<div className='w-full'>
			<label
				className='block text-xl text-black font-semibold mb-2'
				htmlFor='institution-code'
			>
				{label}
			</label>

			<input
				id='institution-code'
				type='text'
				value={value}
				onChange={onChange}
				className='w-full px-4 py-2 rounded-md shadow-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-500'
				placeholder={placeholder}
			/>
		</div>
	);
};

export default TextInput;
